<template>
  <div>
    <vg-heading>基本信息</vg-heading>
    <vg-card>
      <vg-view-field-list class="space-between">
        <vg-view-field
            class="primary"
            label="费用单价"
            :value="value.costUnitPrice | currency('￥')"
        />
        <vg-view-field
            v-if="!costUnitPriceOnly"
            class="primary"
            label="申请人数"
            :value="value.applicantNumber"
        />
        <vg-view-field
            v-if="!costUnitPriceOnly"
            class="primary"
            label="支付总金额"
            :value="value.totalAmountPaid | currency('￥')"
        />
      </vg-view-field-list>
    </vg-card>
  </div>
</template>

<script>
import VgHeading from "@/components/Html/VgHeading.vue";
import VgCard from "@/components/Commons/VgCard.vue";
import VgViewFieldList from "@/components/Commons/VgViewFieldList.vue";
import VgViewField from "@/components/Commons/VgViewField.vue";

export default {
  name: "ChargeDetails",
  components: {VgViewField, VgViewFieldList, VgCard, VgHeading},
  props: {
    value: Object,
    costUnitPriceOnly: Boolean
  }
}
</script>

<style scoped>

</style>